export default __webpack_public_path__ + "static/media/Two2x mobile.c31e096c.jpg";